import './index.css'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './hooks/useAuth'
import PWAInstallPrompt from './components/shared/PWAInstallPrompt'

// Pages
import LoginPage from './pages/LoginPage'
import LandingPage from './pages/LandingPage'
import SchoolSignupPage from './pages/SchoolSignupPage'
import AdminApp from './pages/admin/AdminApp'
import CustomerApp from './pages/customer/CustomerApp'
import InstructorApp from './pages/instructor/InstructorApp'
import TermsOfService from './pages/TermsOfService'
import PrivacyPolicy from './pages/PrivacyPolicy'
import SuperAdminPage from './pages/SuperAdminPage'
import SurfSchoolDirectory from './pages/SurfSchoolDirectory'

function ProtectedRoute({ children, requiredRole }) {
  const { user, profile, loading } = useAuth()
  if (loading) return (
    <div className="loading-screen">
      <div className="spinner" style={{ width: 40, height: 40, borderWidth: 3 }} />
      <p>Loading...</p>
    </div>
  )
  if (!user) return <Navigate to="/" replace />
  if (requiredRole && profile?.role !== requiredRole) return <Navigate to="/" replace />
  return children
}

function Root() {
  const { user, profile, loading } = useAuth()

  if (loading) return (
    <div className="loading-screen">
      <div className="spinner" style={{ width: 40, height: 40, borderWidth: 3 }} />
      <p>Loading WaveSync...</p>
    </div>
  )

  if (!user) return <LandingPage />

  if (profile?.role === 'admin')      return <Navigate to="/admin" replace />
  if (profile?.role === 'instructor') return <Navigate to="/instructor" replace />
  if (profile?.role === 'customer')   return <Navigate to="/customer" replace />

  return <LandingPage />
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Root />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/join/:schoolSlug" element={<SchoolSignupPage />} />
          <Route path="/admin/*" element={
            <ProtectedRoute requiredRole="admin"><AdminApp /></ProtectedRoute>
          } />
          <Route path="/instructor/*" element={
            <ProtectedRoute requiredRole="instructor"><InstructorApp /></ProtectedRoute>
          } />
          <Route path="/customer/*" element={
            <ProtectedRoute requiredRole="customer"><CustomerApp /></ProtectedRoute>
          } />
          <Route path="/super-admin" element={<SuperAdminPage />} />
          <Route path="/directory" element={<SurfSchoolDirectory />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
        </Routes>
        <PWAInstallPrompt />
      </BrowserRouter>
    </AuthProvider>
  )
}
